import { useCallback } from 'react'
import { useSelector } from '@/store'
export function useCheckAuth() {
  // 权限map
  const resourceMap = useSelector((state) => state.auth.authResource || {})
  /**
   * 检查权限
   */
  const checkAuth = useCallback(
    (authCode) => {
      if (!authCode) {
        return true
      }
      return !!resourceMap[authCode]
    },
    [resourceMap]
  )

  return {
    checkAuth,
  }
}
